export const STATUS_CSS = {
  ongoing:   'bg-green-400/15 text-green-400',
  completed: 'bg-blue-400/15 text-blue-300',
  hiatus:    'bg-yellow-400/15 text-yellow-300',
  dropped:   'bg-red-400/15 text-red-300',
}

export const TICKET_STATUS_LABEL = { open: 'Открыто', answered: 'Отвечено', closed: 'Закрыто' }
export const TICKET_STATUS_CSS = {
  open:     'text-blue-400 bg-blue-400/10',
  answered: 'text-accent bg-accent-dim',
  closed:   'text-muted bg-surface2',
}

export const BOOKMARK_STATUSES = [
  { key: 'reading',   label: 'Читаю' },
  { key: 'planned',   label: 'Планирую' },
  { key: 'completed', label: 'Прочитано' },
  { key: 'dropped',   label: 'Брошено' },
]
